import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
    FormControl,
    InputLabel,
    MenuItem,
    Select
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import { myApi } from "../../../config/axiosConfig";
import Cookies from 'js-cookie';

const LOCATIONS = [
    { value: "COLOMBIA", label: "Colombia" },
    { value: "MONTERREY", label: "Monterrey" },
    { value: "ARGUINDEGUI", label: "Arguindegui" }
];

const FUEL_TYPES = [
    { value: "RED", label: "Diesel rojo (Termos)" },
    { value: "CLEAR", label: "Diesel claro (Tractos)" }
];

const emptyForm = {
    location: "COLOMBIA",
    fuel_type: "RED",
    date: dayjs().format("YYYY-MM-DDTHH:mm"),
    quantity: "",
    amount: "",
    iva: "",
    supplier: "",
    invoice: "",
    comments: ""
};

const FuelPurchaseModal = ({
    open,
    onClose,
    carga,
    isEditing,
    defaultLocation,
    tankLevel,
    tankCapacity,
    arguiTanks,
    onCreate,
    onUpdate
}) => {
    const [form, setForm] = useState(emptyForm);
    const [saving, setSaving] = useState(false);
    const fixedLocation = carga?.location || defaultLocation || "COLOMBIA";

useEffect(() => {
    if (open && carga) {
        setForm({
            location: fixedLocation,
            fuel_type: carga.fuel_type || "RED",
            date: carga.date
                ? dayjs(carga.date).format("YYYY-MM-DDTHH:mm")
                : dayjs().format("YYYY-MM-DDTHH:mm"),

            quantity:
                fixedLocation === "ARGUINDEGUI"
                    ? carga.gallons || ""
                    : carga.liters || "",

            //amount: carga.subtotal || carga.total || "",

            amount: carga.subtotal || "",

            iva: carga.iva || "",

            supplier: carga.supplier || "",
            invoice: carga.invoice || "",
            comments: carga.comments || ""
        });
    } else if (open) {
        setForm({
            ...emptyForm,
            location: fixedLocation,
            fuel_type: "RED"
        });
    }
}, [open, carga, defaultLocation, fixedLocation]);

    const toNumber = (value) => {
        if (value === "" || value === null || value === undefined) return 0;
        return Number(String(value).replace(/,/g, "")) || 0;
    };

    const isArguin = fixedLocation === "ARGUINDEGUI";
    //const SAFE_MARGIN = isArguin ? 100 : 500;
    const SAFE_MARGIN = isArguin ? 0 : 0;
    const unitLabel = isArguin ? "gal" : "L";
    //const safeAvailableSpace = Math.max(tankCapacity - tankLevel - SAFE_MARGIN, 0);
    //const safeTankLevel = Math.max(Number(tankLevel) || 0, 0);
    //const safeTankCapacity = Math.max(Number(tankCapacity) || 0, 0);
    const selectedArguiTank = isArguin
        ? arguiTanks?.[form.fuel_type] || { level: 0, capacity: 0 }
        : null;

    const safeTankLevel = isArguin
        ? Math.max(Number(selectedArguiTank?.level) || 0, 0)
        : Math.max(Number(tankLevel) || 0, 0);

    const safeTankCapacity = isArguin
        ? Math.max(Number(selectedArguiTank?.capacity) || 0, 0)
        : Math.max(Number(tankCapacity) || 0, 0);

    const safeAvailableSpace = Math.max(
        safeTankCapacity - safeTankLevel - SAFE_MARGIN,
        0
    );

    const quantity = toNumber(form.quantity);
    const amount = toNumber(form.amount);

    //const iva = isArguin ? 0 : amount * 0.08;
    const iva = isArguin ? 0 : toNumber(form.iva);

    const total = isArguin
        ? amount
        : amount + iva;

    const unitPrice =
        quantity > 0
            ? total / quantity
            : 0;

    const handleChange = (field, value) => {
        setForm(prev => ({
            ...prev,
            [field]: value
        }));
    };

/*     const validate = () => {
        if (!form.location) return "Selecciona una ubicación.";
        if (!form.date) return "Selecciona la fecha.";
        if (quantity <= 0) return "Captura cantidad.";
        if (amount <= 0) return "Captura monto.";

        return null;
    }; */

    const validate = () => 
    {
        if (!form.location) return "Selecciona una ubicación.";
        if (!form.date) return "Selecciona la fecha.";
        if (quantity <= 0) return "Captura cantidad.";
        if (amount <= 0) return "Captura monto.";
        if (!isArguin && form.iva === "") return "Captura IVA.";
        if (!isArguin && iva < 0) return "Captura un IVA válido.";

        //const availableSpace = tankCapacity - tankLevel;

        //if (!isEditing && quantity > availableSpace)
        if (!isEditing && quantity > safeAvailableSpace)
        {
/*             return `La carga excede la capacidad del tanque.

            Disponible: ${availableSpace.toLocaleString()} L`; */

            return `La carga excede la capacidad segura del tanque.

            Disponible: ${safeAvailableSpace.toLocaleString()} ${unitLabel}`;
            //Disponible con margen: ${safeAvailableSpace.toLocaleString()} ${unitLabel}`;
        }

        return null;
    };

    const handleSave = async () => {
        const error = validate();

        if (error) {
            Swal.fire({
                target: document.getElementById('dialogFuelPurchase'),
                icon: "warning",
                title: error
            });
            return;
        }

        setSaving(true);

        try {
            const payload = {
                location: fixedLocation,
                fuel_type: isArguin ? form.fuel_type : null,
                date: dayjs(form.date).format("YYYY-MM-DD HH:mm:ss"),

                liters: isArguin ? 0 : quantity,
                gallons: isArguin ? quantity : 0,

                subtotal: amount,

                iva: iva,

                supplier: isEditing ? form.supplier : "",
                invoice: isEditing ? form.invoice : "",
                comments: isEditing ? form.comments : "",

                usuario: Cookies.get('ebt_nombre'),
            };

            const response = isEditing
                ? await myApi.put(`/cargasFuel/updateFuelPurchase/${carga.id}`, payload)
                : await myApi.post("/cargasFuel/createFuelPurchase", payload);

            if (response.data.success) {
                if (isEditing) {
                    await onUpdate(response.data.data);
                } else {
                    await onCreate(response.data.data);
                }

                Swal.fire({
                    target: document.getElementById('dialogFuelPurchase'),
                    icon: "success",
                    title: isEditing ? "Compra actualizada" : "Compra guardada"
                });

                onClose();
            } else {
                Swal.fire({
                    target: document.getElementById('dialogFuelPurchase'),
                    icon: "error",
                    title: "Error",
                    text: response.data.message || "No se pudo guardar"
                });
            }
        } catch (error) {
            console.error("Error save fuel purchase:", error);

            Swal.fire({
                target: document.getElementById('dialogFuelPurchase'),
                icon: "error",
                title: "Error al guardar"
            });
        } finally {
            setSaving(false);
        }
    };

    return (
        <Dialog id="dialogFuelPurchase" open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle fontWeight={800}>
                {isEditing ? "Editar compra de diesel" : "Agregar compra de diesel"}
            </DialogTitle>

            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6 }}>
{/*                         <FormControl fullWidth>
                            <InputLabel>Ubicación</InputLabel>
                            <Select
                                value={form.location}
                                label="Ubicación"
                                onChange={(e) => handleChange("location", e.target.value)}
                            >
                                {LOCATIONS.map(item => (
                                    <MenuItem key={item.value} value={item.value}>
                                        {item.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl> */}
{/*                         <TextField
                            label="Ubicación"
                            value={LOCATIONS.find(item => item.value === fixedLocation)?.label || fixedLocation}
                            fullWidth
                            InputProps={{
                                readOnly: true
                            }}
                        /> */}
                        <Box>
                            <Box sx={{ fontSize: 12, color: "text.secondary", mb: 0.5 }}>
                                Ubicación
                            </Box>

                            <Box sx={{ fontSize: 18, fontWeight: 700 }}>
                                {LOCATIONS.find(item => item.value === fixedLocation)?.label || fixedLocation}
                            </Box>
                        </Box>
                    </Grid>

                    {isArguin && (
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <FormControl fullWidth>
                                <InputLabel>Tipo de diesel</InputLabel>
                                <Select
                                    value={form.fuel_type}
                                    label="Tipo de diesel"
                                    onChange={(e) => handleChange("fuel_type", e.target.value)}
                                >
                                    {FUEL_TYPES.map(item => (
                                        <MenuItem key={item.value} value={item.value}>
                                            {item.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    )}

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            label="Fecha"
                            type="datetime-local"
                            value={form.date}
                            onChange={(e) => handleChange("date", e.target.value)}
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            label={
                                isArguin
                                    ? "Galones cargados"
                                    : "Litros cargados"
                            }
                            type="number"
                            value={form.quantity}
                            onChange={(e) => handleChange("quantity", e.target.value)}
                            fullWidth
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField
                            label={
                                isArguin
                                    ? "Monto USD"
                                    : "Monto MXN sin IVA"
                            }
                            type="number"
                            value={form.amount}
                            onChange={(e) => handleChange("amount", e.target.value)}
                            fullWidth
                        />
                    </Grid>

                    {!isArguin && (
                        <Grid size={{ xs: 12, sm: 6 }}>
                            <TextField
                                label="IVA MXN"
                                type="number"
                                value={form.iva}
                                onChange={(e) => handleChange("iva", e.target.value)}
                                fullWidth
                            />
                        </Grid>
                    )}

                    <Box sx={{ fontSize: 13, color: "text.secondary", mt: 1 }}>
                        {/* Capacidad: <strong>{tankCapacity.toLocaleString()} {unitLabel}</strong> */}
                        Capacidad: <strong>{safeTankCapacity.toLocaleString()} {unitLabel}</strong>
                        <br />
                        Nivel actual: <strong>{safeTankLevel.toLocaleString()} {unitLabel}</strong>
                        <br />
                        Disponible: <strong>{safeAvailableSpace.toLocaleString()} {unitLabel}</strong>
                    </Box>

                    {isEditing && (
                        <>
                            <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    label="Proveedor"
                                    value={form.supplier}
                                    onChange={(e) => handleChange("supplier", e.target.value)}
                                    fullWidth
                                />
                            </Grid>

                            <Grid size={{ xs: 12, sm: 6 }}>
                                <TextField
                                    label="Factura / Orden"
                                    value={form.invoice}
                                    onChange={(e) => handleChange("invoice", e.target.value)}
                                    fullWidth
                                />
                            </Grid>

                            <Grid size={{ xs: 12 }}>
                                <TextField
                                    label="Comentarios"
                                    value={form.comments}
                                    onChange={(e) => handleChange("comments", e.target.value)}
                                    fullWidth
                                    multiline
                                    rows={2}
                                />
                            </Grid>
                        </>
                    )}

                    <Grid size={{ xs: 12 }}>
                        <Box
                            sx={{
                                p: 2,
                                border: "1px solid #ddd",
                                borderRadius: 2,
                                bgcolor: "#f7f7f7",
                                display: "flex",
                                flexDirection: "column",
                                gap: 1
                            }}
                        >

                            {!isArguin && (
                                <>
                                    <Box>
                                        IVA:
                                        <strong>
                                            {" "}
                                            ${iva.toLocaleString("en-US", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            })}
                                        </strong>
                                    </Box>

                                    <Box>
                                        Total con IVA:
                                        <strong>
                                            {" "}
                                            ${total.toLocaleString("en-US", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            })}
                                        </strong>
                                    </Box>

                                    <Box>
                                        Precio por litro:
                                        <strong>
                                            {" "}
                                            ${unitPrice.toLocaleString("en-US", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            })}
                                        </strong>
                                    </Box>
                                </>
                            )}

                            {isArguin && (
                                <>
                                    <Box>
                                        Precio por galón:
                                        <strong>
                                            {" "}
                                            ${unitPrice.toLocaleString("en-US", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            })}
                                        </strong>
                                    </Box>

                                    <Box>
                                        Total USD:
                                        <strong>
                                            {" "}
                                            ${total.toLocaleString("en-US", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2
                                            })}
                                        </strong>
                                    </Box>
                                </>
                            )}
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions sx={{ p: 2 }}>
                <Button onClick={onClose} color="inherit">
                    Cancelar
                </Button>

                <Button
                    variant="contained"
                    onClick={handleSave}
                    disabled={saving}
                    sx={{ bgcolor: "black", color: "white" }}
                >
                    {saving ? "Guardando..." : "Guardar"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default FuelPurchaseModal;